<template>
    <div style="display: inline-block">
        <b-button v-if="typeButton === 'normal'" class="float-sm-left btn-toolbar sa-btn-icon-text" variant="outline-secondary sa-margin-left" @click="onFirma" :disabled="disabled">
            <b-icon icon="pencil-square"></b-icon>
            Firma Elettronica
        </b-button>
        <b-button v-if="typeButton === 'small'" v-b-tooltip.hover title="Firma Elettronica" size="sm" class="btn btn-outline-info waves-effect waves-light width-sm no-text" variant="outline-secondary sa-margin-left" @click="onFirma" :disabled="disabled">
            <b-icon icon="pencil-square"></b-icon>
        </b-button>

        <b-modal ref="mdlDigitalSignComponentPinRequest" title="P.I.N" @ok="onOk">
            <form ref="form" @submit.stop.prevent="onFirmaSubmit">
                <b-form-group label="P.I.N." label-for="name-input" invalid-feedback="P.I.N. è necessario">
                    <b-form-input type="password" v-model="pinUtente" required placeholder="P.I.N."></b-form-input>
                </b-form-group>
            </form>
        </b-modal>
    </div>
</template>

<script>
import axios from "axios";
export default {
    props: {
        idRiferimento: {
            type: String,
            required: true,
        },
        filename: {
            type: String,
            required: true,
        },
        pdfLink: {
            type: String,
            required: true,
        },
        utente: {
            type: Object,
            required: true,
        },
        tipoDocumento: {
            type: String,
        },
        cognomePaziente: {
            type: String,
        },
        nomePaziente: {
            type: String,
        },
        dataNascitaPaziente: {
            type: Number,
        },
        identificativoPaziente: {
            type: String,
        },
        pathResourceDigitalSign: {
            type: String,
        },
        pdfBase64: {
            type: String,
            default: null,
        },
        codiceApplicativo: {
            type: String,
            default: null,
        },
        posizioneFirma: {
            type: String,
            default: "BOTTOM",
        },
        progressivoFirmatario: {
            type: Number,
            default: 2,
        },
    },
    data() {
        return {
            typeButton: "small",
            disabled: false,
            pinUtente: null,
            aliasUtente: null,
            signUser: {},
            pathResourceDigitalSignUser: "/digitalsignusers",
        };
    },
    methods: {
        digilatSignRequest(signBean) {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceDigitalSign;
            axios
                .post(link, signBean)
                .then(() => {
                    me.$emit("afterSign");
                })
                .catch(() => {
                    me.$emit("closeModal");
                    this.$bvModal
                        .msgBoxOk("Errore durante la firma", {
                            title: "ATTENZIONE",
                            size: "sm",
                            okVariant: "outline-danger",
                            headerClass: "sa-msg-header-danger",
                            footerClass: "p-2 border-top-0",
                            centered: true,
                        })
                        .then(() => {
                            me.$emit("afterSign");
                        })
                        .catch(() => {
                            me.$emit("afterSign");
                        });
                });
        },
        onOk() {
            let me = this;
            me.$refs.mdlDigitalSignComponentPinRequest.hide();
            me.signProcess();
        },
        onFirmaSubmit() {
            let me = this;
            me.$refs.mdlDigitalSignComponentPinRequest.hide();
            me.signProcess();
        },
        onFirma() {
            let me = this;

            let link = process.env.VUE_APP_PATH_API + me.pathResourceDigitalSignUser + "/" + me.utente.id;
            me.$emit("beforeDigitalSignUser");
            axios
                .get(link)
                .then((response) => {
                    me.$emit("afterDigitalSignUser");
                    if (response.data.data.username) {
                        me.signUser = response.data.data;
                        me.aliasUtente = me.signUser.username;
                        me.$refs.mdlDigitalSignComponentPinRequest.show();
                    } else {
                        me.erroreConfigurazione();
                    }
                })
                .catch(() => {
                    // console.log(error);
                    me.erroreConfigurazione();
                    me.$emit("afterDigitalSignUser");
                });
            //
        },
        signProcess() {
            let me = this;
            if (me.pdfBase64) {
                let fileBase64 = me.pdfBase64.replace("data:application/pdf;base64,", "");
                let signBean = {
                    gestore: me.signUser.gestore,
                    tipo: me.signUser.tipo,
                    username: me.aliasUtente,
                    pin: me.signUser.pin,
                    otp: me.pinUtente,
                    files: [{ idRiferimento: me.idRiferimento, filename: me.filename, fileBase64: fileBase64 }],
                    ...me.getDocumentRepository(),
                };
                me.digilatSignRequest(signBean);
                return;
            }

            let link = process.env.VUE_APP_PATH_API + me.pdfLink;
            me.$emit("beforePdfCreate");
            // console.log(me.signUser);

            axios
                .get(link)
                .then((response) => {
                    let signBean = {
                        gestore: me.signUser.gestore,
                        tipo: me.signUser.tipo,
                        username: me.aliasUtente,
                        pin: me.signUser.pin,
                        otp: me.pinUtente,
                        files: [{ idRiferimento: me.idRiferimento, filename: me.filename, fileBase64: response.data.data }],
                        ...me.getDocumentRepository(),
                    };
                    me.digilatSignRequest(signBean);
                })
                .catch((error) => {
                    console.log(error);
                    me.$emit("afterPdfCreate");
                });
        },
        getDocumentRepository() {
            return {
                idRisorsa: this.idRiferimento,
                metadatiJson: "{}",
                base64: null,
                stato: "ATTIVO",
                statoInvioDocumentale: "DA INVIARE",
                statoInvioDocumentaleDataOra: new Date().getTime(),
                statoFirma: "FIRMATO DIGITALMENTE",
                idDocumentale: null,
                cognome: this.cognomePaziente,
                nome: this.nomePaziente,
                dataNascita: this.dataNascitaPaziente,
                codiceFiscale: this.identificativoPaziente,
                tipoDocumento: this.tipoDocumento,
                metadataUtente: '{"name":null,"surname":"","fiscalCode":"","userId":"","username":"","role":"","applicationId":"COT","organizationId":null,"email":""}',
            };
        },
        erroreConfigurazione() {
            let me = this;
            this.$bvModal
                .msgBoxOk("La Firma elettronica non è configurata correttamente!", {
                    title: "ATTENZIONE",
                    size: "sm",
                    okVariant: "outline-danger",
                    headerClass: "sa-msg-header-danger",
                    footerClass: "p-2 border-top-0",
                    centered: true,
                })
                .then(() => {
                    me.$emit("afterSign");
                })
                .catch(() => {
                    me.$emit("afterSign");
                });
        },
    },
};
</script>

<style></style>
